import React from "react";
import {servidor, servicioRestfulCompleto} from "../../Configuracion"
import ClienteRestful from "../../../framework2/ej2/network/ClienteRestful"


export const ESTADO_CHANGE_PAGINA = 'ESTADO_CHANGE_PAGE';
export const ESTADO_CHANGE_PAGINATAB = 'ESTADO_CHANGE_PAGETAB';
export const ESTADO_CHANGE_PAGINAORIGEN = 'ESTADO_CHANGE_PAGEORIGEN';

export const ESTADO_CHANGE_CLINICA = 'ESTADO_CHANGE_CLINICA';


export const ESTADO_LIMPIAR= 'ESTADO_LIMPIAR';


export const PAGE_PRUEBA = 'PAGE_PRUEBA';
export const PAGE_PRINCIPAL = 'PAGE_PRINCIPAL';

export const PAGE_CLINICAS = 'PAGE_CLINICAS';

export const PAGE_DOCTORES = 'PAGE_DOCTORES';

export const PAGE_PACIENTES = 'PAGE_PACIENTES';

export const PAGE_TRATAMIENTOS = 'PAGE_TRATAMIENTOS';

export const PAGE_TRATAMIENTOTIPOS = 'PAGE_TRATAMIENTOTIPOS';

export const PAGE_CITAS = 'PAGE_CITAS';

export const PAGE_HISTORIA = 'PAGE_HISTORIA';

export const PAGE_PAGOS = 'PAGE_PAGOS';

export const PAGE_ROLES = 'PAGE_ROLES';

export const PAGE_USUARIOS = 'PAGE_USUARIOS';

export const PAGE_CONSENTIMIENTOTIPOS = 'PAGE_CONSENTIMIENTOTIPOS';

export const PAGE_SALAESPERA = 'PAGE_SALAESPERA';

export const PAGE_UTILIDADES = 'PAGE_UTILIDADES';

export const estadoLimpiar = () => {
    console.log("REDUX - limpiar");
    return {
        type: ESTADO_LIMPIAR,
    }
}

export const estadoChangePagina = (newPagina) => {
 return {
        type: ESTADO_CHANGE_PAGINA,
        newPagina: newPagina,

    }
}

export const estadoChangePaginaTab = (newPagina, newTab) => {
    //console.log("REDUX - estadoChangePaginaTab");
    //console.log(newPagina);
    //console.log(newTab);
    return {
        type: ESTADO_CHANGE_PAGINATAB,
        newPagina: newPagina,
        newTab: newTab,
    }
}


export const estadoChangePaginaOrigen = (newPaginaOrigen) => {
    return {
        type: ESTADO_CHANGE_PAGINAORIGEN,
        newPaginaOrigen: newPaginaOrigen,
    }
}

export const estadoChangeClinica = (newClinica) => {
    //console.log("estadoChangeClinica: ", newClinica);
    return {
        type: ESTADO_CHANGE_CLINICA,
        newClinica: newClinica,
    }
}

/*
export const loadClinica = (clinicaCodigo) => {
    console.log("LOAD CLINICA: ", clinicaCodigo);
    return (dispatch) => {
        const url = servidor + servicioRestfulCompleto + "Clinica/" + clinicaCodigo;
        //const url = servidor + servicioRestfulMinimo + "Puestotrabajo/" + puestoTrabajoCodigo;
        console.log("url: ", url);
        new ClienteRestful().setUrl(url)
            .doGet(response => {
                let clinica = response;
                console.log("!!!LOADED CLINICA: ", clinica);
                dispatch(estadoChangeClinica(clinica));

            });
    }
}
*/